import { Component, Element, h, Host, Listen, Prop, Watch } from '@stencil/core';
import { default as languageStrings } from '../../global/l10n/OssCustomReelDialog.json';
import Util from '../../global/util';

@Component({
    tag: 'ti-oss-custom-reel-dialog',
    styleUrl: 'oss-custom-reel-dialog.scss',
    shadow: true
})
export class OssCustomReelDialog {

    private _carrierDialog;

    /**
     * The element for this component
     */
    @Element() _hostElement: HTMLTiOpnSnapshotElement;

    /**
     * Value of locale
     *
     * @type {string}
     * @default 'en-US'
     */
    @Prop() locale: string = 'en-US';
    @Watch('locale')
    handleLocaleChange() {
        this.locale = Util.getValidLocale(this.locale);
    }

    /**
    * Listen for a `tiOssCarrierClick` event from opn-details
    *
    * @param event - contains related opn
    */
    @Listen('tiOssCarrierClick', { target: 'window' })
    //@ts-ignore
    async onTiOssCarrierClick(event) {
        event.stopPropagation();
        this._carrierDialog.open();
    }

    render() {
        return (
            <Host>
                <ti-dialog modal ref={el => this._carrierDialog = el}>
                    <h2 slot="title" class="ti-add-to-cart-dialog-title">{languageStrings[this.locale]["carrierDialogTitle"]}</h2>
                    <div>
                        <p innerHTML={languageStrings[this.locale]["carrierDialogMessage"]}></p>
                        <ti-button appearance="link">
                            <a href={languageStrings[this.locale]["carrierDialogLinkUrl"]} target='_blank'>{languageStrings[this.locale]["carrierDialogLink"]}</a>
                        </ti-button>
                    </div>
                </ti-dialog>
            </Host>
        )
    }
}
